import { render, staticRenderFns } from "./Ofertas.vue?vue&type=template&id=17ae2cc5&scoped=true&"
import script from "./Ofertas.vue?vue&type=script&lang=js&"
export * from "./Ofertas.vue?vue&type=script&lang=js&"
import style0 from "./Ofertas.vue?vue&type=style&index=0&id=17ae2cc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ae2cc5",
  null
  
)

export default component.exports